import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withApollo } from '@apollo/client/react/hoc';
import { Route, Redirect, withRouter } from 'react-router-dom';

import * as actions from '../actions/index';
import AddUserMutation from '../graphql/addUser.gql';
import LogErrorMutation from '../graphql/logError.gql';

import { LOG } from '../helpers/utils';
import { sendMessageToLoader } from '../components/utils/helpers';

class PrivateRoute extends Component {
  constructor(props) {
    super(props);

    this.debounce = null;
    this.renderPropComponent = this.renderPropComponent.bind(this);
  }

  componentDidMount() {
    /**
     * Prevent sendPageview when user navigates using router (PUSH action)
     * Also block sendPageview when user is a subscriber (due to router redirects).
     * The pageview trigger for subscriber page is in: /pages/subscriber -> componentDidMount()
     */
    if (this.props.history.action !== 'PUSH' && this.props.authenticated && !this.props.user.isSubscriber) {
      this.props.sendPageview();
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    // After login/logout
    if (newProps.userAction === 'login') {
      sendMessageToLoader('afterLogin');
    } else if (newProps.userAction === 'logout') {
      sendMessageToLoader('afterLogout');
    }

    const {
      sessionId,
      userSessionId,
      currentUserSessionId,
      isNossa
    } = newProps;

    if (this.debounce) {
      clearTimeout(this.debounce);
    }

    // Debounce multiple processes.
    this.debounce = setTimeout(() => {
      const shouldAddUser =
        sessionId
        && userSessionId
        && (!currentUserSessionId || (currentUserSessionId !== userSessionId));

      // Check authenticated user or in new session.
      if (!shouldAddUser || isNossa) {
        return;
      }

      // Add user to session cart.
      this.props.client.mutate({
        mutation: AddUserMutation,
        variables: {
          uuid: sessionId,
          token: userSessionId,
          isNossa
        },
      }).then(({ data }) => {
        // Set user session to store.
        this.props.setUserSession(userSessionId);
        LOG('[apaAnalytics]', 'then', data);

        // Send log message if user was correctly associated with session
        const { email } = this.props.user;
        const message = '[ADD_USER][FRONT] Usuario adicionado a sessao';
        this.props.client.mutate({
          mutation: LogErrorMutation,
          variables: {
            uuid: sessionId,
            logMessage: message,
            email
          },
        }).then(() => {
          LOG('[Graylog][add_user] Graylog received log', message);
        });
      }).catch(({ graphQLErrors }) => {
        try {
          // Set user session to store if the user has been added to the cart.
          // @TODO Add new error handling after implements server error refactor.
          LOG('[apaAnalytics]', 'catch');
          if (graphQLErrors[0].details[0].message === 'O carrinho já possui um usuário associado.') {
            this.props.setUserSession(userSessionId);
          }
        } catch (e) {
          console.error(`Route Error: ${e}`);
        }
      });
    }, 1000);

    this.props.resetUserAction();
  }

  renderPropComponent() {
    const { authenticated, component: Component } = this.props;
    let componentToRender;

    if (authenticated) {
      componentToRender = <Component {...this.props} />;
    } else {
      componentToRender = <Redirect to={{ pathname: '/identifique-se', search: this.props.params }} />;
    }

    return componentToRender;
  }
  render() {
    return <Route render={this.renderPropComponent} />;
  }
}

PrivateRoute.propTypes = {
  history: PropTypes.object,
  component: PropTypes.object,
  location: PropTypes.object,
  resetUserAction: PropTypes.func,
  setUserSession: PropTypes.func,
  client: PropTypes.any,
  sendPageview: PropTypes.func,
  authenticated: PropTypes.bool,
  user: PropTypes.object,
  params: PropTypes.string
};

export default compose(withRouter, withApollo, connect(state => ({
  sessionId: state.SessionReducer.uuid,
  userSessionId: state.UserReducer.token,
  user: state.UserReducer.user,
  currentUserSessionId: state.SessionReducer.userToken,
  isNossa: state.SessionReducer.isNossa,
  metrics: state.MetricsReducer.metrics,
  params: state.MetricsReducer.params
}), {
  ...actions
}))(PrivateRoute);
